import React from 'react';
import './Spinner.css';

export default function Spinner() {
    return (
        <div className="spinner">
            <div className="lds-dual-ring"></div>
        </div>
    )
}
